import { useNavigate } from "react-router-dom";
import { NetworkMap } from "../features/network-map";

export default function NetworkMapPage() {
  const navigate = useNavigate();

  const handleNavigate = (node) => {
    if (!node) return;
    const routes = {
      contact: `/contacts`,
      company: `/companies`,
      opportunity: `/pipeline`,
    };
    navigate(routes[node.type] || "/");
  };

  return (
    <div style={{
      margin: "-28px -36px",
      height: "calc(100vh)",
      overflow: "hidden",
    }}>
      <NetworkMap
        useSampleData={false}
        onNavigate={handleNavigate}
        currencySymbol="\u00a3"
      />
    </div>
  );
}
